module.exports = __webpack_public_path__ + "img/doc-bg.9788ae2f.png";